import { render, staticRenderFns } from "./WriteIn.vue?vue&type=template&id=709f9070&"
import script from "./WriteIn.vue?vue&type=script&lang=js&"
export * from "./WriteIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports